//@import dependencies
import React, { CSSProperties, useState } from 'react'
import { useTranslation } from 'react-i18next'
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap'
// import Container from 'react-bootstrap/Container'
// import Row from 'react-bootstrap/Row'
// import Col from 'react-bootstrap/Col'
//@end

//@import components
import RelatedCoursesModule from 'app_components/modules/campus/academic/relatedCourses'
// import DescriptionCourseModuleSkeleton from 'app_components/modules/academic/descriptioncourse/components/descriptionCourseModuleSkeleton';
import RatingCard from 'app_components/commons/RatingCard/RatingCard';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
//@end

// @import hooks
// @end

// @import types
import { ICourse } from 'app_types/campus/academic/courseTypes'
// @end

// @INFO Import services
import { routingService } from 'app_services/routingService';
import EditorjsService from 'app_services/components/editorjs/editorjsService';
// @end

// @INFO Import Styles
import './../descriptioncourseModule.scss'
import { IoIosAddCircleOutline, IoIosCloseCircleOutline } from 'react-icons/io';

// @ADD Component types

const worldIcon = require('app_assets/images/resources/landing/mundo.svg')
const impulsarIcon = require('app_assets/images/resources/landing/impulsar.svg')
const peopleIcon = require('app_assets/images/resources/landing/people.svg')
const locationIcon = require('app_assets/images/resources/landing/location.svg')

interface IDescriptioncourseModuleLayoutProps {
	course: ICourse | null
}

const DescriptioncourseModuleLayout: React.FC<IDescriptioncourseModuleLayoutProps> = (props) => {

  const [activeKey, updateActiveKey] = useState<string | undefined>(undefined)

  // @INFO Servicios
  const editorjsService = new EditorjsService()

  const { t } = useTranslation()

  return(
    <>
    {props.course && (
      <div className='description-course'>

        <h2
          className='title-section-description'
          style={{ color: 'var(--secondary)', textTransform: 'uppercase' }}
        >
          ¿PORQUÉ IMPULSAR TU DESARROLLO CON ICONTEC?
        </h2>
        <div className="container-impulse-development">
          <ItemImpulse icon={impulsarIcon} content="Somos el Organismo Nacional de Normalización en Colombia,  responsable por la estructuración de las Normas Técnicas Colombianas que se requieren para  impulsar la competitividad de las empresas a nivel nacional e  internacional." />
          <ItemImpulse icon={worldIcon} content="ICONTEC en representación por Colombia, participa activamente en comités internacionales y reuniones técnicas en temas de normas internacionales y  gestión en organizaciones como la ISO, IEC y COPANT." />
          <ItemImpulse icon={peopleIcon} content="Contamos con expertos profesionales en sistemas de gestión que también desarrollan actividades de evaluación de la conformidad y otras actividades como consultoría condición que permite orientar adecuadamente los enfoques técnicos de los referentes en contextos empresariales." />
          <ItemImpulse icon={locationIcon} content="Tenemos presencia a nivel internacional en Suramérica y Centroamérica, lo que nos permite contar con una cobertura amplia y con profesionales competentes en la región." />
        </div>
        <h2
          className='title-section-description'
          style={{ color: 'var(--secondary)', textTransform: 'uppercase' }}
        >
          COMPETENCIAS A DESARROLLAR
        </h2>
        <div>{parse(editorjsService.jsonToHtml(props.course?.extra_info?.competencies?.blocks ? props.course?.extra_info?.competencies?.blocks : []))}</div>

        <Accordion
          activeKey={activeKey}
          onSelect={(_key) => updateActiveKey(_key ? _key : undefined)}
        >
          <AccordionItem
            eventKey='0'
            title='Objetivos'
            currentKey={activeKey}
            blocks={props.course?.extra_info?.objectives?.blocks ? props.course?.extra_info?.objectives?.blocks : []}
          />
          <AccordionItem
            eventKey='1'
            title='Contenido'
            currentKey={activeKey}
            items={props.course?.extra_info?.content?.length ? props.course?.extra_info?.content : []}
          />
          <AccordionItem
            eventKey='2'
            title='¿QUIÉN PUEDE PARTICIPAR?'
            currentKey={activeKey}
            blocks={props.course?.extra_info?.focus?.blocks ? props.course?.extra_info?.focus?.blocks : []}
          />
          <AccordionItem
            eventKey='3'
            title='MATERIALES ORIGINALES DE ICONTEC'
            currentKey={activeKey}
            blocks={props.course?.extra_info?.materials?.blocks ? props.course?.extra_info?.materials?.blocks : []}
          />
          <AccordionItem
            eventKey='5'
            title='METODOLOGÍA'
            currentKey={activeKey}
            blocks={props.course?.extra_info?.methodology?.blocks ? props.course?.extra_info?.methodology?.blocks : []}
          />
          <AccordionItem
            eventKey='6'
            title='CERTIFICACIÓN Y DATOS GENERALES'
            currentKey={activeKey}
            blocks={props.course?.extra_info?.generalities?.blocks ? props.course?.extra_info?.generalities?.blocks : []}
          />
        </Accordion>
        <div className="container-related-courses">
          <h2
            className='title-section-description'
            style={{ color: 'var(--secondary)', textTransform: 'uppercase' }}
          >
            Cursos relacionados
          </h2>
          <div>
            <RelatedCoursesModule
              content="slider"
              exclude={[props.course._id]}
              hideExtraInformation
              breakpointItems={[
                { width: 'default', items: 3 },
                { width: 1410, items: 2 },
                { width: 900, items: 1 },
              ]}
              hidePrice
              size={10}
            />
          </div>
          <div className="btn-links">
            <Link
              className="btn btn-secondary btn-view-moocs"
              to={routingService.getPublicPath('/icontec-resources')}
            >
              <span>Sobre los MOOC</span>
            </Link>
            <Link
              className="btn btn-secondary btn-view-all"
              to={routingService.getPublicPath('/academic-filter')}
            >
              <span>Ver todos</span>
            </Link>
          </div>
        </div>
      </div>
    )}
    </>
  )
}

// ========================================================
// @INFO Item de accordion
// ========================================================
interface IAccordionItemProps {
  eventKey: string
  title: string
  blocks?: any[]
  items?: {data: any, name: string, category: string}[]
  currentKey?: string
  className?: string
  style?: CSSProperties
  id?: string
}

const AccordionItem: React.FC<IAccordionItemProps> = (props) => {

  const editorjsService = new EditorjsService()

  return(
    <Card
      className={`accordion_item-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <Accordion.Toggle
        eventKey={props.eventKey}
        className='toggle-accordion-course'
      >
        <TextComponent
          type='title'
          as='h2'
          style={{
            fontSize: '1.4rem'
          }}
        >
          {props.title}
        </TextComponent>
        {props.currentKey === props.eventKey ?
          <IoIosCloseCircleOutline/>
        :
          <IoIosAddCircleOutline/>
        }
      </Accordion.Toggle>
      <Accordion.Collapse
        eventKey={props.eventKey}
      >
        <Card.Body
          className='collapse-accordion-course'
        >
          {props.blocks ? parse(editorjsService.jsonToHtml(props.blocks)) : null}
          {props.items?.length ?
          props.items.map((_item) => (
            <div
              className="container-item-content-accordion"
              key={_item.name}
            >
              <TextComponent
                type='text'
                style={{
                  fontWeight: 600,
                  color: 'var(--primary)',
                  marginTop: '10px'
                }}
              >
                {_item.name}
              </TextComponent>
              <div
                style={{
                  width: '100%',
                  height: '2px',
                  backgroundColor: '#00BB7E'
                }}
              />
              <TextComponent
                type='text'
              >
                {_item.data?.blocks ? parse(editorjsService.jsonToHtml(_item.data?.blocks)) : _item.data}
              </TextComponent>
              <div
                style={{
                  width: '100%',
                  height: '2px',
                  backgroundColor: '#C1C8C8'
                }}
              />
            </div>
          ))
          :null}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}


// ========================================================
// @INFO Item de impulsar desarrollo
// ========================================================
interface IItemImpulseProps {
  className?: string
  style?: CSSProperties
  id?: string
  content: string
  icon: any
}

const ItemImpulse: React.FC<IItemImpulseProps> = (props) => {
  return(
    <div
      className={`item_impulse-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <img
        src={props.icon}
        alt=""
      />
      <TextComponent
        type='text'
        style={{
          color: 'var(--secondary)'
        }}
      >
        {props.content}
      </TextComponent>
    </div>
  );
}

export default DescriptioncourseModuleLayout
